import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useFastshiftAnalyticsData } from '@/analytics/hooks/use-fastshift-analytics-data';
import { useFireAnalyticsEvents } from '@/analytics/use-fire-analytics-events';

export const useOrganizationDetailsPageAnalytics = () => {
	const { organizationId } = useParams<{
		organizationId: string;
	}>();
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(false);
	const { fireScreenEvent } = useFireAnalyticsEvents(identityAttrs);

	useEffect(() => {
		if (identityAttrs === null) {
			return;
		}

		fireScreenEvent({
			name: sourceKey,
			attributes: { selectedOrgId: organizationId },
		});
	}, [organizationId, identityAttrs, fireScreenEvent, sourceKey]);
};
